module.exports = __webpack_public_path__ + "media/images/shop-c4c4a4cae8857a437f288999f5ff2505.png";